import { Typography } from '@mui/material';

interface Props {
  title: string
}

const CardHeaderText: React.FC<Props> = ({ title }: Props) => (
  <Typography
    variant="h5"
    component="h1"
    sx={(theme) => ({
      alignSelf: 'center',
      display: 'flex',
      alignItems: 'center',
      fontSize: '1.25rem',
      color: theme.palette.primary4,
      fontWeight: theme.typography.fontWeightBold,
      minHeight: '2.28125rem',
    })}
  >
    {title}
  </Typography>
);

export default CardHeaderText;
